import Immutable from "immutable";

import {
  FETCH_COCS,
  FETCH_COCS_ERROR,
  USER_SIGNED_OUT,
} from "../constants/action-types";

const chainOfCustody = Immutable.Record({
  id: undefined,
  name: undefined,
  state: undefined,
  site: undefined,
  received_at: undefined,
  issued_at: undefined,
  user: undefined,
  type: undefined,
  code: undefined,
  samples: undefined,
});

export const chainOfCustodyState = Immutable.Record(
  {
    fetchError: false,
    fetchErrorMessage: "",
    fetchErrorStatus: "",
    // @ts-expect-error legacy opshub typing
    chainOfCustody: new Immutable.Set([]),
  },
  "chainOfCustodyState"
);

export default (state = new chainOfCustodyState(), action) => {
  // @ts-expect-error legacy opshub typing
  let newData = new Immutable.Set([]);
  switch (action.type) {
    case FETCH_COCS:
      action.payload.forEach(function (row) {
        newData = newData.add(new chainOfCustody(row));
      });

      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.chainOfCustody = newData;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
      });

    case FETCH_COCS_ERROR:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.fetchError = true;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = action.payload.message;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = action.payload.status;
      });

    case USER_SIGNED_OUT:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.chainOfCustody = new Immutable.Set([]);
        // @ts-expect-error legacy opshub typing
        s.samples = new Immutable.Set([]);
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
      });

    default:
      return state;
  }
};
